export default __webpack_public_path__ + "static/thumb-landscape-ae0c5ab124cc783c1eb7b0b25bc6f459.jpg";